import React, { memo, useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Rate from '../Rate/Rate';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardFourPart.module.less';
import { hasClass, removeClass, addClass, changeClass } from '../../utils/utils';
import _LogInView from '../_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const optRef = useRef(null);
  const imgRef = useRef(null);
  const gifRef = useRef(null);

  const [isShowGif, setIsShowGif] = useState(false);

  const handleSoftCard = useCallback(() => {
    // 小banner点击
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfo.source || 'SoftCardFourPart_Source_Err',
        source_pp: logInfoData.source_p,
      }),
    );

    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  }, [dispatch, logInfo, history]);

  const onMouseOver = useCallback(
    e => {
      if (optRef && optRef.current) {
        const optDom = optRef.current;
        addClass(optDom, styles.mouse_in);
      }

      if (gifRef && gifRef.current) {
        setIsShowGif(true);
        const gifDom = gifRef.current;
        gifDom.style.display = 'flex';
        changeClass(gifDom, styles.gif_in, styles.gif_out);
        return;
      }
      if (imgRef && imgRef.current) {
        const imgDom = imgRef.current;
        addClass(imgDom, styles.image_mouse_in);
      }
    },
    [imgRef, optRef],
  );

  const onMouseLeave = useCallback(
    e => {
      if (optRef && optRef.current) {
        const optDom = optRef.current;
        addClass(optDom, styles.mouse_out);
      }

      if (gifRef && gifRef.current) {
        setIsShowGif(false);
        const gifDom = gifRef.current;
        changeClass(gifDom, styles.gif_out, styles.gif_in);
        gifDom.style.display = 'none';
        // 小banner hover
        dispatch(
          logging({
            category: 'C',
            action: 'Hover_Video_SoftCard',
            label: '',
            param2: {
              source: logInfo.source || 'SoftCardFourPart_Source_Err',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softID: soft.androidType === '1' ? soft.packageName : soft.softID,
              softType: soft.androidType === '1' ? 1 : 0,
            },
          }),
        );
        return;
      }
      if (imgRef && imgRef.current) {
        const imgDom = imgRef.current;
        addClass(imgDom, styles.image_mouse_out);
      }
    },
    [imgRef, optRef],
  );

  const onAnimationEnd = useCallback(
    e => {
      if (imgRef && imgRef.current) {
        const imgDom = imgRef.current;
        if (hasClass(imgDom, styles.image_mouse_out)) {
          removeClass(imgDom, styles.image_mouse_in);
          removeClass(imgDom, styles.image_mouse_out);
        }
      }
      if (optRef && optRef.current) {
        const optDom = optRef.current;
        if (hasClass(optDom, styles.mouse_out)) {
          removeClass(optDom, styles.mouse_in);
          removeClass(optDom, styles.mouse_out);
        }
      }
    },
    [imgRef, optRef, gifRef],
  );

  return (
    <_LogInView cardData={soft} logInfo={logInfo}>
      <div
        className={styles.soft_card}
        onMouseOver={e => onMouseOver(e)}
        onMouseLeave={e => onMouseLeave(e)}
        onAnimationEnd={e => onAnimationEnd(e)}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <div className={styles.soft_img_box}>
          <img className={styles.soft_img} src={soft.ztImg} alt="" ref={imgRef} />
          {soft.hoverShow === 1 && soft.resUrl && <div className={styles.soft_img_gif} />}
          {soft.hoverShow === 1 && soft.resUrl && (
            <div className={styles.soft_git_box} ref={gifRef}>
              {isShowGif && <img className={styles.soft_git} src={soft.resUrl} alt="" />}
            </div>
          )}
        </div>
        <div className={styles.soft_box}>
          <div className={styles.soft_info}>
            <div className={styles.soft_info_img_box}>
              <img className={styles.soft_info_img} src={soft.logoFile} alt="" />
              {soft.androidType === '1' && <div className={styles.soft_info_img_logo} />}
            </div>
            <div className={styles.soft_info_name_score}>
              <div
                className={styles.soft_name}
                title={(soft.softName && soft.softName.length) > 5 ? soft.softName : ''}
              >
                {soft.softName}
              </div>
              <div className={styles.soft_score_box}>
                <Rate
                  score={(Number(soft.score) / 20).toFixed(1)}
                  rateInfo={{ className: styles.soft_score }}
                />
              </div>
            </div>
          </div>
          <div className={styles.soft_num}>{soft.downloadCount || 0}安装</div>
          <div className={styles.soft_desc}>{soft.introduction || ''}</div>

          <div
            className={styles.soft_opt}
            ref={optRef}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            {soft.androidType === '1' ? (
              <ApkButton
                soft={soft}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                logInfo={{ ...logInfo }}
              />
            ) : (
              <Button
                soft={soft}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                logInfo={{ ...logInfo }}
              />
            )}
          </div>
        </div>
      </div>
    </_LogInView>
  );
});
